import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EngineType } from '../api/types';

const useVehicleEngineTypeOptions = () => {
    const { t } = useTranslation('common');

    return useMemo(
        () => [
            {
                value: EngineType.Petrol,
                label: t('common:options.engineType.petrol'),
            },
            {
                value: EngineType.Diesel,
                label: t('common:options.engineType.diesel'),
            },
            {
                value: EngineType.Hybrid,
                label: t('common:options.engineType.hybrid'),
            },
            {
                value: EngineType.Electric,
                label: t('common:options.engineType.electric'),
            },
        ],
        [t]
    );
};

export default useVehicleEngineTypeOptions;
